import React, {Suspense, useEffect, useState} from 'react';
import {Route, Routes } from 'react-router-dom';
import CustomerRoutes from '../Routes/CustomerRoutes.js';

function App() {
  
  // const {token, setToken } = useToken({});
  useEffect(() => {
    document.title = "centerprism"
  })


  return (
    <div >
      <Routes>
        <Route path='/*' element={<CustomerRoutes/>} />
      </Routes>
    </div>
  );
}

export default App;